import React, { Component } from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
// core components
import Select from "react-select";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import TextField from "@material-ui/core/TextField";
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import { FormControl, InputLabel } from "@material-ui/core";
import GridItem from "components/Grid/GridItem.jsx";
import SimpleReactValidator from "simple-react-validator";
import toastr from "toastr";
import { hist } from "../../..";
import axios from "../../../config/axios";
import "react-datepicker/dist/react-datepicker.css";
import loaderIcon from "assets/img/loader.gif";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import moment from "moment";
import {
  EditorState,
  // ContentState,
  // convertFromHTML,
  // convertToRaw
} from "draft-js";
toastr.options = {
  closeButton: true,
  preventDuplicates: false,
  preventOpenDuplicates: false,
};

const validationStyle = {
  color: "red",
};
/* Editor Component */
const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ font: [] }],
    ["bold", "italic", "underline", "strike"], // toggled buttons
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    ["image"],
    //['link', 'image', 'video'],
    //[{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    ["blockquote", "code-block"],
    //[{ 'direction': 'rtl' }],                         // text direction
    //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    ["clean"], // remove formatting button
  ],
};
class CouponsAdd extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      action: "add",
      eventTypeList: [
        {
          label: "WEBINAR",
          value: "WEBINAR",
        },
        {
          label: "EVENT",
          value: "EVENT",
        },
      ],
      eventType: null,
      id: null,
      coupan_code_number: null,
      limit_usage: null,
      expiry_date: null,
      expiry_time: null,
      editorState: EditorState.createEmpty(),
      eventData: null,
      filterEvents: [],
      selectedEvent: null,
      userData: [],
      selectedUser: null,
      fieldsDisabled: false,
    };
  }

  componentDidMount() {
    this.setState({ loading: true });
    axios
      .get(`/zoom/viewAllUpcomingEventsWebinars`)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          this.setState({
            eventData: res.data.data,
            loading: false,
          });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        toastr.error(error.response.data.message);
      });
    axios
      .get(`/users/user-type/4`)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          let data = res.data.data;
          let filterEvents = [];
          for (let user of data) {
            filterEvents.push({
              label: user.name,
              value: user.id,
            });
          }
          this.setState({
            userData: filterEvents,
            loading: false,
          });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        toastr.error(error.response.data.message);
      });

    if (this.props.location.state) {
      const { action, fieldsDisabled, event } = this.props.location.state;
      if (action === "edit") {
        let {
          active,
          event_type,
          expiry_date,
          terms_and_policy,
          user_id,
          user_name,
          event_id,
          coupan_code_number,
          limit_usage,
          event_name,
          id,
        } = event;
        this.setState({
          eventType: { label: event_type, value: event_type },
          coupan_code_number,
          limit_usage,
          expiry_date: expiry_date
            ? moment(new Date(expiry_date), "LLL")
            : null,
          editorState: terms_and_policy,
          selectedEvent: { label: event_name, value: event_id },
          selectedUser: { label: user_name, value: user_id },
          id,
          action,
          fieldsDisabled,
        });
      }

      if (action === "duplicate") {
        let {
          active,
          event_type,
          expiry_date,
          terms_and_policy,
          user_id,
          user_name,
          event_id,
          coupan_code_number,
          limit_usage,
          event_name,
          id,
        } = event;
        this.setState({
          eventType: { label: event_type, value: event_type },
          coupan_code_number,
          limit_usage,
          expiry_date: expiry_date
            ? moment(new Date(expiry_date), "LLL")
            : null,
          editorState: terms_and_policy,
          selectedEvent: { label: event_name, value: event_id },
          selectedUser: { label: user_name, value: user_id },
          id,
          action,
          fieldsDisabled,
        });

        this.submitDuplicateForm();
      }
    }
  }

  componentDidUpdate(prevProps) {}

  inputHandler = (event) => {
    const { name, value } = event.target;
    if (name === "mobile" && value.length > 12) {
      return toastr.error("Only 12 Digits Mobile No. is allowed!");
    }
    this.setState({ [name]: value });
  };

  inputHandlerName = (event) => {
    const { name, value } = event.target;
    if (name === "coupan_code_number") {
      if (value.length <= 13) {
        this.setState({ [name]: value });
      }
    } else {
      this.setState({ [name]: value });
    }
  };
  submitForm = () => {
    let {
      action,
      eventType,
      loading,
      coupan_code_number,
      limit_usage,
      expiry_date,
      expiry_times,
      editorState,
      selectedEvent,
      selectedUser,
      id,
    } = this.state;
    let requestBody = {
      active: true,
      event_type: eventType.value,
      expiry_date: expiry_times ? expiry_times : expiry_date,
      terms_and_policy: editorState,
      // user_id: selectedUser.value,
      // user_name: selectedUser.label,
      event_id: selectedEvent.value,
      limit_usage,
      coupan_code_number,
      event_name: selectedEvent.label,
    };
    console.log(
      this.validator,
      action,
      requestBody,
      action,
      "inside submitform"
    );
    if (this.validator.allValid()) {
      this.setState({ loading: true });
      if (action === "add" || action === "edit") {
        console.log("at line 251");
        axios
          .post(`events/addneweventcoupans`, requestBody)
          .then((res) => {
            if (res.status === 200 || res.status === 201) {
              // toastr.success("Coupon Created Successfully!");
              toastr.success(res.data.message);
              setTimeout(() => hist.goBack(), 1000);
            }
          })
          .catch((error) => {
            this.setState({ loading: false });
            // toastr.error(error.toString());
            // toastr.error("Please fill the complete details.");
          
            toastr.error(error.response.data.message);
          });
      }
      //  else {
      //   console.log('inside else')
      //   requestBody.id = id;
      //   axios
      //     .post(`events/addneweventcoupans`, requestBody)
      //     .then(res => {
      //       if (res.status === 200 || res.status === 201) {
      //         toastr.success("Coupon Updated Successfully!");
      //         setTimeout(() => hist.goBack(), 1000);
      //       }
      //     })
      //     .catch(error => {
      //       this.setState({ loading: false });
      //       toastr.error(error.response.data.message);
      //     });
      // }
    }
  };

  submitDuplicateForm = () => {
    const { action, fieldsDisabled, event } = this.props.location.state;
    console.log(event, "event in submitDuplicateForm");
    let {
      eventType,
      loading,
      coupan_code_number,
      limit_usage,
      expiry_date,
      expiry_times,
      editorState,
      selectedEvent,
      selectedUser,
      id,
    } = this.state;
    let requestBody = {
      active: true,
      event_type: event.event_type,
      expiry_date: expiry_times ? expiry_times : event.expiry_date,
      terms_and_policy: event.terms_and_policy,
      // user_id: selectedUser.value,
      // user_name: selectedUser.label,
      event_id: event.id,
      limit_usage: event.limit_usage,
      coupan_code_number: event.coupan_code_number,
      event_name: event.event_name,
    };
    console.log(
      this.validator,
      action,
      requestBody,
      "inside submitDuplicateForm"
    );
    // if (this.validator.allValid()) {
    // this.setState({ loading: true });
    if (action === "duplicate") {
      axios
        .post(`events/addneweventcoupans`, requestBody)
        .then((res) => {
          if (res.status === 200 || res.status === 201) {
            toastr.success("Coupon Created Successfully!");
            setTimeout(() => hist.goBack(), 1000);
          }
        })
        .catch((error) => {
          // this.setState({ loading: false });
          // toastr.error(error.toString());
          toastr.error("Please fill the complete details.");
        });
    }

    // else {
    //   requestBody.id = id;
    //   axios
    //     .post(`events/updateeventcoupans`, requestBody)
    //     .then(res => {
    //       if (res.status === 200 || res.status === 201) {
    //         toastr.success("Coupon Updated Successfully!");
    //         setTimeout(() => hist.goBack(), 1000);
    //       }
    //     })
    //     .catch(error => {
    //       this.setState({ loading: false });
    //       toastr.error(error.response.data.message);
    //     });
    // }
    // }
  };

  eventTypeSeclection = (inputValue) => {
    let allEvents = this.state.eventData;
    let filterEvents = [];
    for (let event of allEvents) {
      if (event.event_webinar === inputValue.value) {
        filterEvents.push({
          label: event.name,
          value: event.id,
        });
      }
    }
    this.setState({
      eventType: inputValue,
      filterEvents,
    });
    console.log(filterEvents);
  };

  render() {
    const {
      eventTypeList,
      eventType,
      loading,
      coupan_code_number,
      limit_usage,
      expiry_date,
      expiry_times,
      editorState,
      filterEvents,
      selectedEvent,
      userData,
      selectedUser,
      fieldsDisabled,
    } = this.state;
    return (
      <div className="add-category-form webinar">
        <Card className="vip_main" style={{ overflow: "-webkit-paged-x" }}>
          {loading ? (
            <div className="loader_icon">
              <img src={loaderIcon} />
            </div>
          ) : (
            <React.Fragment>
              <CardContent>
                <form>
                  <GridContainer className="coupon_main">
                    <GridItem md={12}>
                      <FormControl
                        // className={classes.formControl}
                        className="select_cp"
                        fullWidth
                        style={{ margin: "0.7rem 0" }}
                      >
                        <legend style={{ fontSize: "1rem" }}>
                          Select Event Type
                        </legend>
                        <Select
                          name="category"
                          options={eventTypeList}
                          value={eventType}
                          isDisabled={fieldsDisabled}
                          onChange={(inputValue, actionMeta) => {
                            if (inputValue) {
                              this.eventTypeSeclection(inputValue);
                            }
                          }}
                          className="basic-multi-select"
                          classNamePrefix="select"
                        />
                      </FormControl>
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "Event Type",
                            eventType,
                            "required"
                          )}
                        </span>
                      }
                    </GridItem>

                    <GridItem md={12}>
                      <FormControl
                        className="select_cp1"
                        fullWidth
                        style={{ margin: "0.7rem 0" }}
                      >
                        <legend style={{ fontSize: "1rem" }}>
                          Select Event
                        </legend>
                        <Select
                          name="category"
                          options={filterEvents}
                          value={selectedEvent}
                          isDisabled={fieldsDisabled}
                          onChange={(inputValue, actionMeta) => {
                            if (inputValue) {
                              this.setState({
                                selectedEvent: inputValue,
                              });
                            }
                          }}
                          className="basic-multi-select"
                          classNamePrefix="select"
                        />
                      </FormControl>
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "Select Event",
                            selectedEvent,
                            "required"
                          )}
                        </span>
                      }
                    </GridItem>

                    {/* <GridItem md={12}>
                        <FormControl
                          className="select_cp2"
                          fullWidth
                          style={{ margin: "0.7rem 0" }}
                        >
                          <legend style={{ fontSize: "1rem" }}>Select User ID</legend>
                          <Select
                            name="category"
                            isDisabled={fieldsDisabled}
                            options={userData}
                            value={selectedUser}
                            onChange={(inputValue, actionMeta) => {
                              if (inputValue) {
                                this.setState({
                                  selectedUser: inputValue
                                });
                              }
                            }}
                            className="basic-multi-select"
                            classNamePrefix="select"
                          />
                        </FormControl>
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "Select User Id",
                              selectedUser,
                              "required"
                            )}
                          </span>
                        }
                      </GridItem> */}

                    <GridItem md={12}>
                      <TextField
                        InputLabelProps={{
                          shrink: coupan_code_number ? true : false,
                        }}
                        autoFocus
                        margin="dense"
                        id="coupan_code_number"
                        name="coupan_code_number"
                        label="Coupon code number*"
                        type="text"
                        fullWidth
                        disabled={fieldsDisabled}
                        value={coupan_code_number}
                        autocomplete="off"
                        onChange={(event) => {
                          this.inputHandlerName(event);
                        }}
                      />
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "Coupon Code Number",
                            coupan_code_number,
                            "required"
                          )}
                        </span>
                      }
                    </GridItem>

                    <GridItem className="date_text coupon" md={8}>
                      <InputLabel shrink={true}>
                        Coupon Expiry Date &amp; Time
                      </InputLabel>
                      <DatePicker
                        selected={expiry_date}
                        disabled={fieldsDisabled}
                        onChange={(date) => {
                          let toISOString = date.toISOString();
                          this.setState({
                            expiry_times: toISOString,
                            expiry_date: date,
                          });
                        }}
                        showTimeSelect={true}
                        dateFormat="LLL"
                        // maxDate={setMaxDate}
                        minDate={new Date()}
                        placeholderText="Select Date"
                      />

                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "expiry_date",
                            expiry_date,
                            "required"
                          )}
                        </span>
                      }
                    </GridItem>

                    <GridItem md={4}>
                      <TextField
                        InputLabelProps={{
                          shrink: limit_usage ? true : false,
                        }}
                        autoFocus
                        margin="dense"
                        id="limit_usage"
                        name="limit_usage"
                        label="Limit"
                        type="number"
                        fullWidth
                        disabled={fieldsDisabled}
                        value={limit_usage}
                        autocomplete="off"
                        onChange={(event) => {
                          this.inputHandlerName(event);
                        }}
                      />
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "Limit Number",
                            limit_usage,
                            "required"
                          )}
                        </span>
                      }
                    </GridItem>

                    <GridItem md={12}>
                      <InputLabel shrink={true}>
                        Complete Description
                      </InputLabel>

                      <ReactQuill
                        disabled={fieldsDisabled}
                        onChange={(newValue, delta, source) => {
                          //console.log("onChange newValue:::: ", newValue, delta)
                          this.setState({ editorState: newValue });
                        }}
                        onBlur={(range, source, quill) => {
                          //console.log("onBlur quill.getHTML():::: ", quill.getHTML(), range, source,quill, quill.getLength(), quill.getText())
                          console.log(quill.getHTML());
                        }}
                        modules={modules}
                        theme="snow"
                        value={editorState}
                      />
                      <p>
                        *Please upload the images only in 692px x 400px
                        resolution
                      </p>
                    </GridItem>
                  </GridContainer>
                </form>
              </CardContent>
              <CardActions style={{ float: "right" }}>
                {!fieldsDisabled ? (
                  <Button
                    variant="contained"
                    color="iseas"
                    onClick={this.submitForm}
                  >
                    Submit
                  </Button>
                ) : null}
              </CardActions>
            </React.Fragment>
          )}
        </Card>
      </div>
    );
  }
}

// const mapStateToProps = state => {
//   return {
//     categoryListData: state.category,
//     speakerListData: state.speaker
//   };
// };

// const mapDispatchToProps = dispatch => {
//   return {
//     handleGetCategoryList: () => dispatch(getAllCategories$.trigger()),
//     handleGetSpeakerList: () => dispatch(getAllSpeakers$.trigger())
//   };
// };

export default connect()(withStyles(extendedFormsStyle)(CouponsAdd));



// WEBPACK FOOTER //
// ./src/views/ISEAS/coupon/add.js